module.exports = __webpack_public_path__ + "img/chevron-down.35a74c25.svg";